var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({},'v-icon',_vm.$attrs,false),[_vm._v("fas fa-"+_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }